<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-redo`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31.879 24.778a1 1 0 000 1.414l1.414 1.415a1 1 0 001.414 0l9.193-9.193a2 2 0 000-2.828l-9.193-9.193a1 1 0 00-1.414 0l-1.414 1.415a1 1 0 000 1.414l5.778 5.777L18.414 15c-7.732 0-14 6.268-14 14s6.268 14 14 14h8.729a1 1 0 001-1v-1.96a1 1 0 00-1-1h-8.26c-3.865 0-10-4.001-10-10.04 0-6.039 6.135-10 10-10h18.773l-5.777 5.778z"/></svg>
</template>
<script>

export default {
  name: 'IconRedo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
